export default class BlogPost {
  constructor(entry) {
    this.sys = entry?.sys || {};
    this.fields = entry?.fields || {};

    this.id = this.sys.id || "";
    this.title = this.fields.title || "Untitled Post";
    this.slug = this.fields.slug || this.id;
    this.author = this.fields.author || "";
    this.publishDate = this.fields.publishDate
      ? new Date(this.fields.publishDate)
      : new Date(this.sys.createdAt || Date.now());
    const rawDesc = (this.fields.shortDescription || "").trim();
    if (!rawDesc) {
      this.shortDescription = "";
    } else {
      const cleanDesc = rawDesc.replace(/[.\s…]+$/, "");
      const truncated =
        cleanDesc.length > 247
          ? cleanDesc.slice(0, 247).trim()
          : cleanDesc;
      this.shortDescription = truncated ? `${truncated}...` : "";
    }
    this.content = this.fields.content || null;
    this.category = this.fields.category || "";

    // Parse images: supports fields.images (array) or fields.image / fields.mainImage (single)
    this.images = this.#extractImages(this.fields);
    this.featuredImage = this.images.length > 0 ? this.images[0] : null;
    this.galleryImages = this.images.length > 1 ? this.images.slice(1) : [];
  }

  getLink() {
    return `/blog/${this.slug}`;
  }

  getFormattedDate() {
    return this.publishDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  #extractImages(fields) {
    const raw =
      fields.images || fields.image || fields.featuredImage || fields.mainImage;
    if (!raw) return [];

    const list = Array.isArray(raw) ? raw : [raw];
    const parsed = [];

    for (const img of list) {
      if (img?.url) {
        const url = img.url.startsWith("//") ? `https:${img.url}` : img.url;
        parsed.push({
          url,
          title: img.title || img.description || this.title,
          description: img.description || "",
          contentType: img.contentType || "image/jpeg",
          width: img.width,
          height: img.height,
        });
        continue;
      }

      const file = img?.fields?.file;
      if (file?.url) {
        const url = file.url.startsWith("//") ? `https:${file.url}` : file.url;
        parsed.push({
          url,
          title: img.fields?.title || img.fields?.description || this.title,
          description: img.fields?.description || "",
          contentType: file.contentType,
          width: file.details?.image?.width,
          height: file.details?.image?.height,
        });
      }
    }

    return parsed;
  }
}
